// @ts-strict-ignore
import {
	Event,
	EventColors,
	ISimSession,
	ScenarioRecordingArchiveExternView,
	ScenarioRecordingArchiveView,
	TrainingSessionScenarioRecordingArchiveExternView,
	TrainingSessionScenarioRecordingArchiveView,
} from "@models";
import {EventApi} from "@fullcalendar/core";

export interface VMEventDay {
	date: Date | string;
	sessions: ISimSession[];
}

export interface VMEvent {
	isSingleDayEvent: boolean;
	isSelected: boolean;
	days: VMEventDay[];
}

export function getColorForEvent(event: Event | null): string {
	if (!event) {
		return "";
	}

	let eventColor = event.eventColor;
	if (!eventColor) {
		eventColor = EventColors.EVENT_COLOR_ONE;
	}

	switch (eventColor) {
		case EventColors.EVENT_COLOR_ONE:
			return "#279989";
		case EventColors.EVENT_COLOR_TWO:
			return "#a38b00";
		case EventColors.EVENT_COLOR_THREE:
			return "#006ec5";
		case EventColors.EVENT_COLOR_FOUR:
			return "#d35d00";
		case EventColors.EVENT_COLOR_FIVE:
			return "#e9005b";
		case EventColors.EVENT_COLOR_SIX:
			return "#7d36ad";
		case EventColors.EVENT_COLOR_SEVEN:
			return "#c53737";
		case EventColors.EVENT_COLOR_EIGHT:
			return "#4a9500";
	}
}

export interface VMIsSelected {
	isSelected: boolean;
}

export interface TrainingSessionScenarioRecordingArchiveViewVM extends TrainingSessionScenarioRecordingArchiveView {
	recordings: (ScenarioRecordingArchiveView & VMIsSelected)[];
}

export interface TrainingSessionScenarioRecordingArchiveExternViewVM extends TrainingSessionScenarioRecordingArchiveExternView {
	recordings: (ScenarioRecordingArchiveExternView & VMIsSelected)[];
}

export function dateHelperEvent_addDaysToDate(date: Date, daysToAdd: number): Date {
	const tempDate = new Date(date.valueOf());
	tempDate.setDate(date.getDate() + daysToAdd);
	return tempDate;
}

export function dateHelperEvent_getEventDays(event: Event): VMEventDay[] {
	const dateArray: VMEventDay[] = [];
	let currentDate = new Date(event.start);
	while (currentDate <= new Date(event.end)) {
		dateArray.push({date: new Date(currentDate), sessions: []});
		currentDate = dateHelperEvent_addDaysToDate(currentDate, 1);
	}
	return dateArray;
}

export function dateHelperEventForCalendar_getEventDays(event: EventApi): VMEventDay[] {
	const dateArray: VMEventDay[] = [];
	let currentDate = new Date(event.start);
	while (currentDate <= new Date(event.end)) {
		dateArray.push({date: new Date(currentDate), sessions: []});
		currentDate = dateHelperEvent_addDaysToDate(currentDate, 1);
	}
	return dateArray;
}

export function dateHelperEvent_sameDay(d1: Date, d2: Date) {
	return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

export function dateHelperEvent_isMultiDayEvent(event: Event): boolean {
	let erg = dateHelperEvent_sameDay(new Date(event.start), new Date(event.end));
	return !erg;
}

export function dateHelperEventFromCalendar_containsDate(event: EventApi, date: Date) {
	for (let eventDay of dateHelperEventForCalendar_getEventDays(event)) {
		if (dateHelperEvent_sameDay(new Date(eventDay.date), date)) {
			return true;
		}
	}
	return false;
}
